<template>

    <div>

        <div class="top-gradient"></div>

        <transition :name="transitionName">
            <keep-alive include="booking-clinic">
              <router-view></router-view>
            </keep-alive>
        </transition>

        <div class="bottom-menu" v-if="auth || app_version === 'customer_card'">

            <div class="container-fluid px-3" v-if="app_version === 'customer_card' && fetcher.initialized">

                <div class="row gx-2">
                    <div :class="{ 'col-4-5' : hasHadCardMassage, 'col-8' : !hasHadCardMassage }">
                        <router-link class="bottom-menu-item" active-class="active" :exact="true" :to="linkTo('')">
                            <img class="icon" src="/images/card/bottom-menu-item-book.svg?ver=3">
                            <img class="icon-active" src="/images/card/bottom-menu-item-book-active.svg?ver=3">
                            <div class="w-100">Boka tid</div>
                        </router-link>
                    </div>
                    <div :class="{ 'col-4-5' : hasHadCardMassage, 'col-8' : !hasHadCardMassage }">
                        <router-link class="bottom-menu-item" active-class="active" :to="linkTo('/cards')">
                            <img class="icon" src="/images/card/bottom-menu-item-treatments.svg?ver=3">
                            <img class="icon-active" src="/images/card/bottom-menu-item-treatments-active.svg?ver=3">
                            <div class="w-100">Klippkort</div>
                        </router-link>
                    </div>
                    <div class="col-4-5" v-if="hasHadCardMassage">
                        <router-link class="bottom-menu-item" active-class="active" :to="linkTo('/shop')">
                            <div class="notification-count" v-if="showShopCount">1</div>
                            <img class="icon" src="/images/card/bottom-menu-item-shop.svg?ver=3">
                            <img class="icon-active" src="/images/card/bottom-menu-item-shop-active.svg?ver=3">
                            <div class="w-100">Köp</div>
                        </router-link>
                    </div>
                    <div class="col-4-5" v-if="hasHadCardMassage">
                        <router-link class="bottom-menu-item" active-class="active" :to="linkTo('/tipsa')">
                            <div class="notification-count" v-if="showReferralCount">1</div>
                            <img class="icon" src="/images/card/bottom-menu-item-referral.svg?ver=3">
                            <img class="icon-active" src="/images/card/bottom-menu-item-referral-active.svg?ver=3">
                            <div class="w-100">Få massage</div>
                        </router-link>
                    </div>
                    <div :class="{ 'col-4-5' : hasHadCardMassage, 'col-8' : !hasHadCardMassage }">
                        <router-link class="bottom-menu-item" active-class="active" :to="linkTo('/faq')">
                            <img class="icon" src="/images/card/bottom-menu-item-help.svg?ver=3">
                            <img class="icon-active" src="/images/card/bottom-menu-item-help-active.svg?ver=3">
                            <div class="w-100">Hjälp</div>
                        </router-link>
                    </div>
                </div>

            </div>

            <div class="container-fluid px-3" v-if="app_version === 'company_card'">

                <div class="row gx-2">
                    <div class="col-5">
                        <!--                        <a class="bottom-menu-item" :class="{ 'active' : activePage == 'booking' || activePage == 'booking-on-location' || activePage == 'booking-select-type' }" @click.stop="setActivePage('booking')">-->
                        <router-link class="bottom-menu-item" active-class="active" :class="{'active': $route.name === 'booking' || $route.name === 'booking-workplace'}" :exact="true" to="/">
                            <img class="icon" src="/images/card/bottom-menu-item-book.svg">
                            <img class="icon-active" src="/images/card/bottom-menu-item-book-active.svg?ver=2">
                            <div class="w-100">Boka tid</div>
                        </router-link>
                    </div>
                    <div class="col-7">
                        <router-link class="bottom-menu-item" active-class="active" to="/treatments">
                            <img class="icon" src="/images/card/bottom-menu-item-treatments.svg">
                            <img class="icon-active" src="/images/card/bottom-menu-item-treatments-active.svg">
                            <div class="w-100">Behandlingar</div>
                        </router-link>
                    </div>
                    <div class="col-7">
                        <router-link class="bottom-menu-item" active-class="active" to="/faq">
                            <img class="icon" src="/images/card/bottom-menu-item-help.svg">
                            <img class="icon-active" src="/images/card/bottom-menu-item-help-active.svg?ver=2">
                            <div class="w-100">Hjälp & FAQ</div>
                        </router-link>
                    </div>
                    <div class="col-5">
                        <router-link class="bottom-menu-item" active-class="active" to="/account">
                            <img class="icon" src="/images/card/bottom-menu-item-account.svg">
                            <img class="icon-active" src="/images/card/bottom-menu-item-account-active.svg">
                            <div class="w-100">Konto</div>
                        </router-link>
                    </div>
                </div>

            </div>

        </div>

        <div class="message-window-container" :class="{ 'show': showEndingMessage }" v-if="app_version === 'company_card'" @click="closeEndingMessage()">

            <div class="message-window" @click.stop>
                <h2 class="mb-4 text-warning">Massage genom din arbetsplats upphör snart att gälla</h2>
                <p class="mb-4">Efter <b>{{ subscription_status.date }}</b> slutar din arbetsgivare att erbjuda massage genom arbetet.
                    Det innebär att <b>du inte får ersättning</b> av din arbetsgivare för behandlingar som utförs efter detta datum.</p>
                <button class="btn btn-warning w-100 text-white" @click="closeEndingMessage()">Stäng</button>
                <div class="mt-4 text-center"><span class="link" @click="closeEndingMessage('cookie')">Visa inte igen</span></div>
            </div>

        </div>

        <div class="message-window-container" :class="{ 'show': showEndedMessage }" v-if="app_version === 'company_card'" @click="closeEndedMessage()">

            <div class="message-window" @click.stop>
                <h2 class="mb-4 text-warning">Du kan inte längre boka massage</h2>
                <p class="mb-4">Efter <b>{{ subscription_status.date }}</b> slutade din arbetsgivare att erbjuda massage genom arbetsplatsen.
                    Det innebär att du inte längre kan boka massage via Hälsoresurs.</p>
                <button class="btn btn-warning w-100 text-white" @click="closeEndedMessage()">Stäng</button>
                <div class="mt-4 text-center"><span class="link" @click="closeEndedMessage('cookie')">Visa inte igen</span></div>
            </div>

        </div>

        <div class="message-window-container" :class="{ 'show': showDemoMessage }" v-if="app_version !== 'company_card'" @click="closeDemoMessage()">

            <div class="message-window" @click.stop>
                <h2 class="mb-4">Detta är ett DEMO-kort</h2>
                <p class="mb-4">Syftet med DEMO-kortet är att lära dig hur appen fungerar. Det går inte att boka eller registrera på riktigt.</p>
                <button class="btn btn-primary w-100 text-white" @click="closeDemoMessage('cookie')">Jag förstår</button>
            </div>

        </div>

        <div class="message-window-container show-only-standalone" :class="{ 'show': showReferralMessage == true && showModalForcePhone == false }" v-if="app_version !== 'company_card'" @click="closeReferralMessage()">

            <div class="message-window" @click.stop>
                <div class="btn-close" @click="closeReferralMessage()"></div>
                <div class="w-50 d-flex mx-auto mb-8 mt-4">
                    <div class="round-image">
                        <img src="/images/card/illustration-kram.png">
                    </div>
                </div>
                <h1 class="mb-3">Få en gratis massage!</h1>
                <p class="mb-8 large-text">Värva dina vänner till oss. När de köper sitt första klippkort får du en massage som tack.</p>
                <button class="btn btn-primary w-100 text-white" @click="closeReferralMessage('route')">Läs mer</button>
            </div>

        </div>

        <div class="add-to-home-screen" :class="{ 'active' : showAddToHomeScreen }"
             v-if="$route.meta.hideAddToHomeScreen !== true">
            <div class="close" @click="closeAddToHomeScreen()"><div class="label">Stäng</div><div class="btn-close"></div></div>

            <picture class="illustration">
              <source srcset="/images/card/add-to-home-screen.webp" type="image/webp">
              <source srcset="/images/card/add-to-home-screen.png" type="image/png">
              <img src="/images/card/add-to-home-screen.png" class="illustration">
            </picture>

            <div class="w-100 d-flex justify-content-center">
                <div class="w-100 px-4" style="max-width: 320px;">

                    <h2 v-if="$route.query.registered">Ditt konto har skapats!<br>Spara appen på din telefon:</h2>
                    <h2 v-else-if="$route.query.activated">Ditt konto har aktiverats!<br>Spara appen på din telefon:
                    </h2>
                    <h1 v-else>Spara Hälsoresurs<br>app på din telefon:</h1>

                    <!-- iPhone with safari - detected by css -->
                    <div class="instructions iphone">

                        <!-- iPhone with Chrome for iOs - detected by javascript -->
                        <div class="w-100" v-if="isChromOnIos">

                            <div class="instructions-row">
                                <div class="instructions-icon" style="background-color: #e7eaed;"><img src="/images/card/add-to-home-screen-icon1-chromeios.png">
                                </div>
                                <p>1. Tryck på delnings-symbolen längst upp till höger.</p>
                            </div>
                            <div class="instructions-row">
                                <div class="instructions-icon"><img src="/images/card/add-to-home-screen-icon2-iphone.png?ver=1">
                                </div>
                                <p>2. Scrolla ner och välj “Lägg till på hemskärmen”.</p>
                            </div>
                            <div class="instructions-row">
                                <div class="instructions-icon"><img src="/images/card/add-to-home-screen-icon3.png"></div>
                                <p>3. Öppna appen och boka din första behandling.</p>
                            </div>

                        </div>

                        <!-- iPhone with safari - detected by css and hidden is it is chrome ios -->
                        <div class="w-100" v-else>
                            <div class="instructions-row">
                                <div class="instructions-icon"><img src="/images/card/add-to-home-screen-icon1-iphone.png">
                                </div>
                                <p>1. Tryck på delnings-symbolen längst ner i webbläsaren.</p>
                            </div>
                            <div class="instructions-row">
                                <div class="instructions-icon"><img src="/images/card/add-to-home-screen-icon2-iphone.png?ver=1">
                                </div>
                                <p>2. Scrolla ner och välj “Lägg till på hemskärmen”.</p>
                            </div>
                            <div class="instructions-row">
                                <div class="instructions-icon"><img src="/images/card/add-to-home-screen-icon3.png"></div>
                                <p>3. Öppna appen och boka din första behandling.</p>
                            </div>
                        </div>

                    </div>

                    <!-- Android - detected by css -->
                    <div class="instructions android">

                        <div v-if="showInstallButton">
                            <button class="btn btn-primary my-2" @click="installApp">Spara appen här</button>
                            <h3 class="instructions-toggle-head text-dark" :class="{ 'toggle' : toggleInstructions }" @click="toggleInstructions = !toggleInstructions">
                                <span>Spara appen manuellt</span>
                                <img src="/images/card/icon-arrow.svg" class="fold-icon">
                            </h3>
                        </div>

                        <div class="w-100" :class="{ 'instructions-toggle' : showInstallButton, 'instructions-toggle-show' : toggleInstructions }">

                            <!-- Android with samsung brower - detected by javascript -->
                            <div class="w-100" v-if="isSamsungBrowser">

                                <div class="instructions-row">
                                    <div class="instructions-icon"><img src="/images/card/add-to-home-screen-icon1-samsungbrowser.png">
                                    </div>
                                    <p>1. Klicka på menyn längst ner till höger.</p>
                                </div>
                                <div class="instructions-row">
                                    <div class="instructions-icon"><img src="/images/card/add-to-home-screen-icon2-samsungbrowser.png">
                                    </div>
                                    <p>2. Väj "Lägg till på sida" och sedan "Hemskärm".</p>
                                </div>
                                <div class="instructions-row">
                                    <div class="instructions-icon"><img src="/images/card/add-to-home-screen-icon3.png"></div>
                                    <p>3. Öppna appen och boka din första behandling.</p>
                                </div>

                            </div>

                            <!-- Android with chrome - detected by css and hidden if it is samsung browser -->
                            <div class="w-100" v-else>

                                <div class="instructions-row">
                                    <div class="instructions-icon"><img src="/images/card/add-to-home-screen-icon1-android.png?ver=1">
                                    </div>
                                    <p>1. Klicka på prickarna längst upp till höger.</p>
                                </div>
                                <div class="instructions-row">
                                    <div class="instructions-icon"><img src="/images/card/add-to-home-screen-icon2-android.png?ver=1">
                                    </div>
                                    <p>2. Välj "Lägg till på startskärmen" och sedan "Installera".</p>
                                </div>
                                <div class="instructions-row">
                                    <div class="instructions-icon"><img src="/images/card/add-to-home-screen-icon3.png"></div>
                                    <p>3. Öppna appen och boka din första behandling.</p>
                                </div>

                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </div>

        <div class="add-to-home-screen-bg" @click="closeAddToHomeScreen()" :class="{ 'active' : showAddToHomeScreen }"
             v-if="$route.meta.hideAddToHomeScreen !== true"></div>

        <modalForcePhone @showModal="(val) => showModalForcePhone = val" v-if="app_version === 'customer_card'" />

    </div>

</template>

<script>
import fetcher from '../../../shared/mixins/fetcher'

import Cookies from 'js-cookie'

import modalForcePhone from '../customer/modal-force-phone.vue'
import notification from '../shared/notification.vue'
import jQuery from 'jquery'

export default {

    mixins: [
        fetcher
    ],

    components: {
        modalForcePhone,
        notification
    },

    data () {
        return {
            showAddToHomeScreen: false,
            transitionName: 'fade',
            activePage: '',
            showEndingMessage: false,
            showEndedMessage: false,
            showWelcomeMessage: false,
            showDemoMessage: false,
            showModalForcePhone: false,
            is_demo: window.is_demo,
            app_title: window.app_title,
            app_url: window.app_url,
            deferredPrompt: null,
            showInstallButton: false,
            isChromOnIos: false,
            isSamsungBrowser: false,
            toggleInstructions: false,
            showReferralMessage: false,
            showReferralCount: false,
            active_cards: [],
            has_had_product_areas: [],
            fetcher: {
                fetchOnCreated: window.app_version === 'customer_card',
                autoFill: [
                    'active_cards',
                    'has_had_product_areas'
                ]
            }
        }
    },

    computed: {
        fetcherUrl () {
            return '/cards'
        },

        showShopCount () {
            if (this.active_cards.length == 0 && this.fetcher.initialized) {
                return true
            }
            return false
        },

        hasHadCardMassage () {
            return this.has_had_product_areas.indexOf(1) !== -1
        },

        hasHadCardPt () {
            return this.has_had_product_areas.indexOf(2) !== -1
        }
    },

    mounted () {
        setTimeout(() => {
            this.activePage = 'booking'
        }, 50)

        if (this.subscription_status && this.subscription_status.status === 'ending') {
            this.showEndingMessage = true

            if (Cookies.get('hideEndingMessage') == 1) {
                this.showEndingMessage = false
            }
        }

        if (this.subscription_status && this.subscription_status.status === 'ended') {
            this.showEndedMessage = true

            if (Cookies.get('hideEndedMessage') == 1) {
                this.showEndedMessage = false
            }
        }

        this.showWelcomeMessage = true
        if (Cookies.get('hideWelcomeMessage') == 1 || window.localStorage.getItem('hideWelcomeMessage') == 1) {
            this.showWelcomeMessage = false
        }

        if (this.is_demo == 1) {
            this.showDemoMessage = true
            if (Cookies.get('hideDemoMessage') == 1 || window.localStorage.getItem('hideDemoMessage') == 1) {
                this.showDemoMessage = false
            }
        }

        this.showAddToHomeScreen = true
        if (Cookies.get('hideAddToHomeScreen') == 1) {
            this.showAddToHomeScreen = false
        }

        this.showReferralMessage = false
        setTimeout(() => {
            if (Cookies.get('hideReferralMessage') != 1) {
                if(this.hasHadCardMassage)
                {
                   this.showReferralMessage = true 
                }
            }
        }, 2500)

        this.showReferralCount = false
        if (Cookies.get('hideReferralCount') != 1) {
            this.showReferralCount = true
        }

        window.addEventListener('beforeinstallprompt', this.handleBeforeInstallPrompt)

        if (navigator.userAgent.match('CriOS')) {
            this.isChromOnIos = true
        }

        if (navigator.userAgent.match('SamsungBrowser')) {
            this.isSamsungBrowser = true
        }
    },

    beforeDestroy () {
        window.removeEventListener('beforeinstallprompt', this.handleBeforeInstallPrompt)
    },

    watch: {
        '$route' (to, from) {
            console.log('from ' + from.name)
            console.log('to ' + to.name)

            if (from.name === 'cards' && to.name === 'card') {
                this.transitionName = 'slide'
            } else if (from.name === 'card' && to.name === 'cards') {
                this.transitionName = 'slideback'
            } else if (from.name === 'booking' && to.name === 'booking-workplace') {
                this.transitionName = 'slide'
            } else if (from.name === 'booking-workplace' && to.name === 'booking') {
                this.transitionName = 'slideback'
            } else {
                this.transitionName = 'fade'
            }

            console.log('transitionName ' + this.transitionName)

            if (to.name !== 'card-clinic' && to.name !== 'treatments-clinic' && from.name !== 'card-clinic' && from.name !== 'treatments-clinic') {
                jQuery('body,html').scrollTop(0)
            }

            if (to.name === 'tipsa') {
                Cookies.set('hideReferralCount', 1, { expires: 730 })
                this.showReferralCount = false
            }

            if (window.app_version === 'customer_card') {
                this.fetcherFetch()
            }
        }
    },

    methods: {

        closeEndingMessage (mode = '') {
            if (mode == 'cookie') {
                Cookies.set('hideEndingMessage', 1, { expires: 90 })
            }

            this.showEndingMessage = false
        },

        closeEndedMessage (mode = '') {
            if (mode == 'cookie') {
                Cookies.set('hideEndedMessage', 1, { expires: 90 })
            }

            this.showEndedMessage = false
        },

        closeWelcomeMessage () {
            window.localStorage.setItem('hideWelcomeMessage', 1)
            this.showWelcomeMessage = false
        },

        closeDemoMessage (mode = '') {
            if (mode == 'cookie') {
                Cookies.set('hideDemoMessage', 1, { expires: 90 })
                window.localStorage.setItem('hideDemoMessage', 1)
            }
            this.showDemoMessage = false
        },

        closeReferralMessage (mode = '') {
            Cookies.set('hideReferralMessage', 1, { expires: 730 })
            this.showReferralMessage = false

            if (mode == 'route') {
                this.matomoTrackEvent('Referral', 'Notis 1', 'Knapp')
                this.$router.push({ name: 'tipsa' })
            }
        },

        closeAddToHomeScreen () {
            Cookies.set('hideAddToHomeScreen', 1, { expires: 7 })
            this.showAddToHomeScreen = false
        },

        handleBeforeInstallPrompt (e) {
            // Prevent the mini-infobar from appearing on mobile
            e.preventDefault()
            // Save the event for later use
            this.deferredPrompt = e
            this.showInstallButton = true
            console.log('beforeinstallprompt event captured')
        },

        installApp () {
            if (this.deferredPrompt) {
                this.deferredPrompt.prompt()
                this.deferredPrompt.userChoice.then((choiceResult) => {
                    console.log(`User response: ${choiceResult.outcome}`)
                    if (choiceResult.outcome === 'accepted') {
                        console.log('User accepted the install prompt')
                    } else {
                        console.log('User dismissed the install prompt')
                    }
                    this.deferredPrompt = null
                    this.showInstallButton = false
                })
            }
        }

    }
}
</script>
<style type="text/css">

/* --- Fade transition --- */
.fade-enter-active, .fade-leave-active {
    transition: all 250ms;
}

.fade-enter, .fade-leave-to {
    opacity: 0;
    left: 0;
    position: absolute;
}

@media only screen and (min-width: 768px) {
    .fade-enter, .fade-leave-to {
        left: auto;
        position: static;
    }
}

/* --- Slide left transition --- */
.slide-enter-active, .slide-leave-active {
    transition: all 250ms;
    position: absolute;
}

.slide-enter, .slide-leave-to {
    transform: translate(100%, 0);
    opacity: 0;
    position: absolute;
}

.slide-leave-to {
    transform: translate(-100%, 0);
    opacity: 0;
    position: absolute;
}

/* --- Slide right transition --- */
.slideback-enter-active, .slideback-leave-active {
    transition: all 250ms;
    position: absolute;
}

.slideback-enter, .slideback-leave-to {
    transform: translate(-100%, 0);
    opacity: 0;
    position: absolute;
}

.slideback-leave-to {
    transform: translate(100%, 0);
    opacity: 0;
    position: absolute;
}

.slideback-enter-active .page-header, .slideback-leave-active .page-header, .slideback-enter .page-header, .slideback-leave-to .page-header {
    display: none !important;
}

@media only screen and (min-width: 768px) {

    .slide-enter-active, .slide-leave-active {
        transition: all 250ms;
        position: static;
    }

    .slide-enter, .slide-leave-to {
        transform: translate(0, 0);
        position: static;
    }

    .slide-leave-to {
        transform: translate(0, 0);
        position: static;
    }

    /* --- Slide right transition --- */
    .slideback-enter-active, .slideback-leave-active {
        transition: all 250ms;
        position: static;
    }

    .slideback-enter, .slideback-leave-to {
        transform: translate(0, 0);
        position: static;
    }

    .slideback-leave-to {
        transform: translate(0, 0);
        position: static;
    }

}

</style>
